var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultPageMenu',{attrs:{"name":"cleaning","routes":Array('cleaning_main', 'cleaning_services', 'cleaning_seo')}})}
var staticRenderFns = []

export { render, staticRenderFns }